import { render } from "./VxHome.vue?vue&type=template&id=4cce8c2a"
import script from "./VxHome.vue?vue&type=script&lang=js"
export * from "./VxHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__